import {useMutation, useQuery} from '@tanstack/react-query';

import {
  RQ_APPOINTMENT_ADD_API,
  RQ_APPOINTMENT_BOOKING_API,
  RQ_APPOINTMENT_DELETE_API,
  RQ_APPOINTMENT_LOOKUP_API,
  RQ_APPOINTMENT_LOOKUP_ID_API,
  RQ_APPOINTMENT_UPDATE_API,
} from './Constants';
import {rqCreateRequest} from './rqHttpUtils';

const withUrl = (config, key, value) => ({
  ...config,
  url: config.url.replace(`<%= ${key} %>`, value),
});

//  Add Appointment
export const RQAppointmentAddAPI = (options = {}) =>
  useMutation({
    mutationKey: ['rq_add_appointment'],
    mutationFn: async ({formData, token}) => {
      if (!formData) {
        throw new Error('formData is undefined');
      }

      return rqCreateRequest(
        RQ_APPOINTMENT_ADD_API,
        formData,
        token,
        null,
      );
    },
    ...options,
  });

//  Update Appointment
export const RQAppointmentUpdateAPI = (options = {}) =>
  useMutation({
    mutationKey: ['rq_update_appointment'],
    mutationFn: async ({id, formData, token}) => {
      return rqCreateRequest(
        withUrl(RQ_APPOINTMENT_UPDATE_API, 'id', id),
        formData,
        token,
        null,
      );
    },
    ...options,
  });

//  Lookup All Appointments

export const RQAppointmentLookupAPI = (
  token,
  options = {},
) =>
  useQuery({
    queryKey: ['rq_lookup_appointments'],
    queryFn: () =>
      rqCreateRequest(
        RQ_APPOINTMENT_LOOKUP_API,
        null,
        token,
        null,
      ).then(res => res ?? []),
    enabled: !!token,
    ...options,
  });

//  Lookup Appointment By Id
export const RQAppointmentLookupByIdAPI = (
  id,
  token,
  options = {},
) =>
  useQuery({
    queryKey: ['rq_lookup_appointment', id],
    queryFn: () =>
      rqCreateRequest(
        withUrl(RQ_APPOINTMENT_LOOKUP_ID_API, 'id', id),
        null,
        token,
        null,
      ),
    enabled: !!id && !!token,
    ...options,
  });

export const RQAppointmentBookingAPI = (
  bookingType,
  token,
  options = {},
) =>
  useQuery({
    queryKey: ['rq_lookup_booking_type', bookingType],
    queryFn: () =>
      rqCreateRequest(
        withUrl(
          RQ_APPOINTMENT_BOOKING_API,
          'bookingType',
          bookingType,
        ),
        null,
        token,
        null,
      ).then(res => res ?? []),
    enabled: !!bookingType && !!token,
    ...options,
  });

//   Delete Appointment
export const RQDeleteAppointmentAPI = (callbacks = {}) =>
  useMutation({
    mutationKey: ['rq_delete_appointment'],
    mutationFn: ({id, token}) =>
      rqCreateRequest(
        withUrl(RQ_APPOINTMENT_DELETE_API, 'id', id),
        null,
        token,
        null,
      ),
    ...callbacks,
  });
